import { InjectionKey } from 'vue'
import { createStore, useStore as baseUseStore, Store } from 'vuex'

interface State {
  message: string | null;
  messageType: 'success' | 'error';
}

interface APIError {
  message?: string;
  json?: Record<string, Record<string, string[]>>;
}

export const key: InjectionKey<Store<State>> = Symbol('store')

export const store = createStore<State>({
  state: {
    message: null,
    messageType: 'success'
  },
  mutations: {
    setMessage (state, message: string) {
      state.message = message
    },
    setMessageType (state, messageType: 'success' | 'error') {
      state.messageType = messageType
    }
  },
  actions: {
    showAPIError ({ dispatch }, error: APIError) {
      const errors = error.json?.errors
      dispatch('showErrorMessage', error.message || (errors && errors[0]))
    },
    showMessage ({ commit, dispatch }, message: string) {
      commit('setMessageType', 'success')
      commit('setMessage', message)
      setTimeout(() => dispatch('hideMessage'), 5000)
    },
    showErrorMessage ({ commit, dispatch }, message: string) {
      commit('setMessageType', 'error')
      commit('setMessage', message)
      setTimeout(() => dispatch('hideMessage'), 60000)
    },
    hideMessage ({ commit }) {
      commit('setMessage', null)
    }
  }
})

// ref. https://next.vuex.vuejs.org/guide/typescript-support.html#simplifying-usestore-usage
export function useStore () {
  return baseUseStore(key)
}
